import ResetPassword from './resetPassword';
export default ResetPassword;
